export default "__VITE_ASSET__BD$iuCE3__"